module.exports = __webpack_public_path__ + "static/media/dragAndDrop-step2.fc222259.png";